@if (shouldShow) {
  <div class="messaging-wrapper">
    @if (isV2) {
      <!-- V2: Progress bars -->
      <qai-call-insight-card
        class="messaging-card"
        [heading]="heading"
        [description]="description"
        [headingMode]="'large'"
        [descriptionMode]="'simple'"
        [showLink]="false"
        [objectiveFooterLabel]="objectiveFooterLabel()"
        [applyFadeGradientAtBottom]="metrics().length > 5"
        (viewAllWithObjectiveCount)="onViewAllObjectivesV2()"
      >
        <div qaiSlot="content">
          @if (metrics().length === 0) {
            <p class="no-metrics-message">{{ noMetricsMessage }}</p>
          } @else {
            @for (m of displayedMetrics(); track m.sectionName) {
              <qai-progress-bar
                class="messaging-progress-bar"
                [value]="m.percentageCorrect"
                [max]="100"
                [segments]="5"
                [kind]="getKindByPercentage(m.percentageCorrect)"
                [shape]="'round'"
                [size]="'medium'"
                [label]="m.sectionName"
                [labelVariant]="'bold'"
                [description]="localeService.formatScoreValue(m.percentageCorrect.toString(), 1) + '%'"
              ></qai-progress-bar>
            }
          }
        </div>
      </qai-call-insight-card>
    } @else if (isV1) {
      <!-- V1: Segmented bar graphs -->
      <qai-call-insight-card
        class="messaging-card"
        [heading]="heading"
        [description]="description"
        [headingMode]="'large'"
        [descriptionMode]="'simple'"
        [showLink]="false"
        [legend]="v1Legend"
        [objectiveFooterLabel]="objectiveFooterLabel()"
        [applyFadeGradientAtBottom]="messageAdherenceData().length > 5"
        (viewAllWithObjectiveCount)="onViewAllObjectivesV1()"
      >
        <div qaiSlot="content">
          @if (messageAdherenceData().length === 0) {
            <p class="no-metrics-message">{{ noMetricsMessage }}</p>
          } @else {
            <div class="messaging-segmented-bars-container">
            @for (item of displayedMessageAdherenceData(); track item.articulationTitle) {
              <qai-segmented-bar-graph
                class="messaging-segmented-bar"
                [label]="item.articulationTitle"
                [total]="100"
                [segments]="mapToSegments(item.articulationProgress)"
                [ariaLabel]="generateAriaLabel(item.articulationProgress)"
              ></qai-segmented-bar-graph>
              }
              </div>
          }
        </div>
      </qai-call-insight-card>
    }
  </div>

  <app-simulation-detail-list-modal
    #listModal
    [heading]="heading"
    [subheading]="modalSubheading()"
  >
    @if (isV2) {
      @for (m of metrics(); track m.sectionName) {
        <qai-progress-bar
          class="messaging-progress-bar"
          [value]="m.percentageCorrect"
          [max]="100"
          [segments]="5"
          [kind]="getKindByPercentage(m.percentageCorrect)"
          [shape]="'round'"
          [size]="'medium'"
          [label]="m.sectionName"
          [labelVariant]="'bold'"
          [description]="localeService.formatScoreValue(m.percentageCorrect.toString(), 1) + '%'"
        ></qai-progress-bar>
      }
    } @else if (isV1) {
      <div class="messaging-segmented-bars-container">
        @for (item of messageAdherenceData(); track item.articulationTitle) {
          <qai-segmented-bar-graph
            class="messaging-segmented-bar"
            [label]="item.articulationTitle"
            [total]="100"
            [segments]="mapToSegments(item.articulationProgress)"
            [ariaLabel]="generateAriaLabel(item.articulationProgress)"
          ></qai-segmented-bar-graph>
        }
      </div>
    }
  </app-simulation-detail-list-modal>
}
